import { render, staticRenderFns } from "./starter.vue?vue&type=template&id=b2823c94"
import script from "./starter.js?vue&type=script&lang=js&external"
export * from "./starter.js?vue&type=script&lang=js&external"
import style0 from "./starter.vue?vue&type=style&index=0&id=b2823c94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports